import React from 'react';

interface ThreeDotLoaderProps {
  className?: string;
}

const ThreeDotLoader: React.FC<ThreeDotLoaderProps> = ({
  className = 'flex items-center justify-center py-8',
}) => {
  return (
    <div className={className}>
      <style>{`
        @keyframes pulse-shade-size {
          0%,
          80%,
          100% {
            background-color: #d1d5db;
            transform: scale(1);
          }
          40% {
            background-color: #6b7280;
            transform: scale(1.2);
          }
        }
        .dot {
          width: 1.5rem;
          height: 1.5rem;
          background-color: #d1d5db;
          border-radius: 50%;
          animation: pulse-shade-size 1.4s infinite ease-in-out;
        }
        .dot:nth-child(1) {
          animation-delay: -0.32s;
        }
        .dot:nth-child(2) {
          animation-delay: -0.16s;
        }
      `}</style>
      <div className='flex space-x-3 mr-auto'>
        <div className='dot'></div>
        <div className='dot'></div>
        <div className='dot'></div>
      </div>
    </div>
  );
};

export default ThreeDotLoader;
